export function isPreviewBootstrapLocation(url) {
    return (url.pathname === '/__pplx_preview/' &&
        /^preview--[pts]--[a-f0-9]{32}\.pplx\.app$/.test(url.hostname));
}
//# sourceMappingURL=previewUrl.js.map